module.exports = __webpack_public_path__ + "resources/img/page-bg1.5d908f79.png";